<template>

  <div v-loading="loading" style="width: 1200px;margin: 60px auto 0 auto;">

    <div>
      <el-form :inline="true" :model="request" class="demo-form-inline" size="small">
        <el-form-item>
          <el-input v-model="request.likeUsername" placeholder="请输入用户名" style="width: 350px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">立即查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div>
      <el-table
        :data="table.data"
        style="width: 100%">
        <el-table-column label="用户名" prop="username">
        </el-table-column>
        <el-table-column label="学习任务" prop="name">
          <template #default="scope">
            <el-tag style="margin-right: 10px;margin-bottom: 5px;"
                    size="small"
                    v-for="(learnSeries, idx) in scope.row.learnSeriesList" :key="idx">
              {{learnSeries.seriesName}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="最近登录时间" prop="lastLoginDate">
        </el-table-column>
        <el-table-column label="操作">
          <template #default="scope">
            <el-button
              size="mini"
              @click="restLastUserRecord(scope.row.username)">重置登录时间
            </el-button>
            <el-button
              size="mini"
              type="danger"
              @click="openLearnTaskTransfer(scope.row.userId, scope.row.learnSeriesList)">分配学习任务
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div style="text-align: center;margin-top: 15px;">
      <el-pagination
        :hide-on-single-page="true"
        layout="prev, pager, next"
        @current-change="getData"
        v-model:currentPage="request.current"
        :page-size="request.size"
        :total="table.total">
      </el-pagination>
    </div>

    <el-dialog
      title="分配学习任务"
      :visible.sync="transferDialogVisible"
      width="38%"
      :loading="transferLoading"
      center>
      <el-transfer v-model="transferData.value"
                   :data="transferData.data"
                   :sourceValue="transferData.sourceValue"
                   :titles="['待分配任务', '已分配任务']"></el-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button @click="transferDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeLearnTask">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
  import { doGetAllLearnTask, doGetPageUserInfo, doChangeLearnTask, restLastUserRecord} from '@/utils/server';

  export default {
    name: "userlist",
    data() {
      return {
        loading: false,
        transferLoading: false,
        transferDialogVisible: false,
        request: { likeUsername: '', current: 1, size: 10 },
        table: {
          total: 0,
          data: []
        },
        allLeanTask: [],
        transferData: {
          value: [],
          data: [],
          sourceValue: []
        }
      }
    },
    methods: {
      restLastUserRecord(username) {
        restLastUserRecord({username:username})
          .then(response => {
            this.getPageUserInfo();
          })
      },
      openLearnTaskTransfer(userId, selfLeanTask) {
        this.transferData.data = [];
        this.transferData.value = [];
        this.transferData.sourceValue = [];

        let data = [];
        this.allLeanTask.forEach(function (item) {
          data.push({
            key: item.seriesCode,
            label: item.seriesName,
            disabled: false
          });
        });

        let value = [];
        selfLeanTask.forEach(function (item) {
          value.push(item.seriesCode);
        });

        this.transferData.data = data;
        this.transferData.value = value;
        this.transferData.sourceValue = value;
        this.transferData.targetUserId = userId;
        this.transferDialogVisible = true;
      },
      getData(val) {
        this.request.current = val;
        this.getPageUserInfo();
      },
      getAllLearnTask() {
        doGetAllLearnTask({})
          .then(response => {
            this.allLeanTask = response.data;
          })
      },
      getPageUserInfo() {
        let request = { ...this.request };
        this.loading = true;
        doGetPageUserInfo(request)
          .then(response => {
            this.table.total = response.total;
            this.table.data = response.data;
            this.loading = false;
          })
      },
      changeLearnTask() {
        let request = {
          targetUserId: this.transferData.targetUserId,
          seriesCodeList: this.transferData.value,
          originalSeriesCodeList: this.transferData.sourceValue
        };
        this.transferLoading = true;
        doChangeLearnTask(request)
          .then(response => {
            this.transferLoading = true;
            this.transferDialogVisible = false;

            // 页面查询加载
            this.getPageUserInfo();
          });
      },
    },
    mounted() {
      this.getAllLearnTask();
      this.getPageUserInfo();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/learntask/userlist.vue